import { useToast } from '@chakra-ui/react'
import { sendPasswordResetEmail } from 'firebase/auth'
import useHandleError from './useHandleError'
import useStore from '../store/useStore'
import { primaryServices } from '../utils/firebaseServiceContext'
import { auditBlockedImpersonationAction } from '../utils/impersonationAudit'

export default () => {
  const toast = useToast()
  const handleError = useHandleError()
  const isImpersonating = useStore(
    (state) => state.identityStatus === 'impersonating',
  )

  return (email: string) => {
    if (isImpersonating) {
      void auditBlockedImpersonationAction('account.password-reset')
      toast({
        status: 'error',
        title: 'Read-only session',
        description: 'Password reset is disabled while acting as a user.',
      })
      return Promise.resolve()
    }
    return sendPasswordResetEmail(primaryServices.auth, email)
      .then(() => {
        toast({
          status: 'success',
          title: 'Password Reset Email Sent',
          description: `Sent to email address: ${email}. Please also check your spam folder.`,
          duration: 10000,
          isClosable: true
        })
      })
      .catch(handleError)
  }
}
